import { SHAPE_STROKE_PROPS } from './stroke-props';

interface ChevronProps {
  strokeDasharray: string | undefined;
}

export default function Chevron({ strokeDasharray }: ChevronProps) {
  return (
    <polygon
      points="0,0 75,0 100,50 75,100 0,100 25,50"
      strokeDasharray={strokeDasharray}
      {...SHAPE_STROKE_PROPS}
    />
  );
}
